import { useLang } from "@/i18n";

export default function ReviewsCta({ onBook }) {
  const { t } = useLang();
  return (
    <>
      <section id="excellence" className="py-24 px-6 border-b border-[#212631]" data-testid="reviews-section">
        <div className="max-w-6xl mx-auto">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#c9a24d] block mb-2">{t("rev.kicker")}</span>
            <h2 className="font-disp text-3xl md:text-4xl text-white">{t("rev.title")}</h2>
          </div>

          <div className="bg-[#0d1017] border border-[#c9a24d]/30 rounded-2xl p-8 md:p-12 text-center max-w-3xl mx-auto shadow-2xl" data-testid="reviews-empty-state">
            <div className="w-12 h-12 rounded-full bg-[#12151e] border border-[#c9a24d]/40 text-[#c9a24d] flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            </div>
            <h3 className="font-disp text-2xl text-white mb-2">{t("rev.emptyTitle")}</h3>
            <p className="text-sm text-[#8c98a9] max-w-md mx-auto mb-6">
              {t("rev.emptyText")}
            </p>
            <button onClick={onBook} data-testid="reviews-cta-button"
              className="font-geom inline-block px-6 py-2.5 text-xs uppercase font-bold bg-[#12151e] text-[#c9a24d] rounded-full hover:bg-[#1a1f2b] transition-colors border border-[#c9a24d]/40">
              {t("rev.cta")}
            </button>
          </div>
        </div>
      </section>

      <section className="py-24 px-6 bg-gradient-to-b from-[#060709] to-[#10141d]" data-testid="final-cta-section">
        <div className="max-w-4xl mx-auto text-center">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#c9a24d] block mb-3">{t("cta.kicker")}</span>
          <h2 className="font-disp text-4xl md:text-5xl text-white mb-6">{t("cta.title")}</h2>
          <p className="text-sm md:text-base text-[#8c98a9] max-w-xl mx-auto mb-8 font-light">
            {t("cta.sub")}
          </p>
          <button onClick={onBook} data-testid="final-cta-button"
            className="font-geom px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] bg-gradient-to-r from-[#c9a24d] via-[#d9b86c] to-[#a17c2e] text-[#060709] hover:brightness-110 transition-all rounded-full shadow-2xl shadow-[#c9a24d]/30 border border-[#e3c07a]/40 inline-block">
            {t("cta.btn")}
          </button>
        </div>
      </section>
    </>
  );
}
